module.exports = __webpack_public_path__ + "static/media/smsIntegration.dbbfe24a.svg";